import { IFilterPureDescriptor, IOptionalDescriptorProps, IRequiredDescriptorProps } from '../../types/interfaces';
import { mergeDeepWith, concat } from 'ramda';

export function descriptorsFactory(globals: IRequiredDescriptorProps & Partial<IOptionalDescriptorProps>) {
  return (...locals: IOptionalDescriptorProps[]) =>
    locals.map(local => mergeDeepWith(concat, local, globals)) as IFilterPureDescriptor[];
}
